import useLarvaVisibilityWatch from '../hooks/useLarvaVisibilityWatch';

function LarvaVisibilityWatcher(): null {
    useLarvaVisibilityWatch();

    return null;
}

export default LarvaVisibilityWatcher;
